import { Nullable } from '@/shared/types/app.types'
import { StatisticalAnalysisViewDetailChartData, StatisticalAnalysisViewDetailChartFilters } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart/statistical-analysis-view-detail-chart.model'
import { delayAndResponseTimesDossierService } from '@/modules/statistical-analysis-module/services/delay-and-response-times-dossier/delay-and-response-times-dossier.service'
import { StatisticalAnalysisDelaysAndResponseTimeDossierExternalInfo } from '@/modules/statistical-analysis-module/views/delays-and-response-time-dossier/delays-and-response-time-dossier.model'
import { StatisticalAnalysisDelayAndResponseTimesDetailRequestChart } from '@/modules/statistical-analysis-module/services/delay-and-response-times-dossier/delay-and-response-times-dossier.dto'
import { StatiscalAnalysisTypeCases, StatisticalAnalysisDelayAndResponseEnum, StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelectorEnum } from '@/modules/statistical-analysis-module/shared/models/shared.model'
import { Options } from 'highcharts'
import i18n from '@/lang/i18n'
import { CommonPersonnelResponse } from '@/api/services/common/personnel/common-personnel.dto'
import { StatisticalAnalysisViewDetailChartFilterByEnumAllowed } from '@/modules/statistical-analysis-module/shared/components/statistical-analysis-view-detail-chart-filters-extended/statistical-analysis-view-detail-chart-filters-extended.model'

export class StatisticalAnalysisHandlerChartDelayAndTimeResponsesDossier {
    protected statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailChartFilters>

    constructor(statisticalAnalysisFilters: Nullable<StatisticalAnalysisViewDetailChartFilters>) {
        this.statisticalAnalysisFilters = statisticalAnalysisFilters
    }

    public async getChart(): Promise<Options> {
        const sidebarFilter = this.statisticalAnalysisFilters?.externalFiltering.sidebarFilters as StatisticalAnalysisDelaysAndResponseTimeDossierExternalInfo
        const baseRequest = delayAndResponseTimesDossierService.getBaseRequest(sidebarFilter)
        let detailRequest: StatisticalAnalysisDelayAndResponseTimesDetailRequestChart = {
            filterTimeSheetId: sidebarFilter.filterTimeSheetId?.id!
        }
        const filterIds = this.statisticalAnalysisFilters?.filterByIds!.map((item: CommonPersonnelResponse) => item.id)
        const additionalFilterBy = (this.statisticalAnalysisFilters?.additionalFilterBy?.id as StatisticalAnalysisViewDetailChartFilterByEnumAllowed)
        const additionalFilterById = (this.statisticalAnalysisFilters?.additionalFilterById?.id as number)
        if (filterIds?.length) {
            detailRequest = {
                ...detailRequest,
                filterIds
            }
        }
        if (additionalFilterBy) {
            detailRequest = {
                ...detailRequest,
                additionalFilterBy
            }
        }
        if (additionalFilterById) {
            detailRequest = {
                ...detailRequest,
                additionalFilterById
            }
        }
        const timeMeasureType = sidebarFilter.typeDelaysAndResponseTimes?.id as StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelectorEnum
        if (timeMeasureType === StatisticalAnalysisDelaysAndResponseTimeGeneralResponseTimeSelectorEnum.DELAY) {
            detailRequest = {
                ...detailRequest,
                delayType: sidebarFilter?.typeDelay
            }
        }
        const typeCase = sidebarFilter?.typeSearch?.id as StatiscalAnalysisTypeCases
        const responseTimeType = sidebarFilter.trackingDetailSelected?.key as StatisticalAnalysisDelayAndResponseEnum
        let entityTypeId = {}
        switch (typeCase) {
        case StatiscalAnalysisTypeCases.CASE:
            entityTypeId = { caseTypeId: sidebarFilter?.trackingGeneralSelected?.key as number }
            break
        case StatiscalAnalysisTypeCases.SAMPLE:
            entityTypeId = { sampleTypeId: sidebarFilter?.trackingGeneralSelected?.key as number }
            break
        case StatiscalAnalysisTypeCases.PORTION:
            entityTypeId = { portionTypeId: sidebarFilter?.trackingGeneralSelected?.key as number }
            break
        case StatiscalAnalysisTypeCases.SUBPORTION:
            entityTypeId = { subportionTypeId: sidebarFilter?.trackingGeneralSelected?.key as number }
            break
        default:
            entityTypeId = {}
        }
        const response: StatisticalAnalysisViewDetailChartData = await delayAndResponseTimesDossierService.getDetailViewChart(typeCase, timeMeasureType, responseTimeType, baseRequest, detailRequest, this.statisticalAnalysisFilters as StatisticalAnalysisViewDetailChartFilters, entityTypeId)
        return {
            xAxis: {
                categories: response.categories
            },
            yAxis: {
                title: {
                    text: `${i18n.tc('statisticalAnalysis.charts.totalOf')} ${i18n.tc(sidebarFilter.typeSearch!.text, 2).toLocaleLowerCase()}`
                }
            },
            series: response.series
        }
    }
}
